/**
 * Decides on what colour to return given the value of errorMessage
 * - if errorMessage is defined we return the error colour
 * - if errorMessage is undefined, we return the default colour
 *
 * @example
 *  const getEitherDefaultOrErrorPrimaryColour = getColourDeciderGivenAnError(errorMessage)('#C62828');
 *
 *  // This helper can now be utilised in other components that have an error state
 *  const iconColour = getEitherDefaultOrErrorPrimaryColour('#000000');
 *  const textColour = getEitherDefaultOrErrorPrimaryColour('#123456)
 *
 * @param {string} errorMessage
 */
export var getColourDeciderGivenAnError = function (errorMessage) { return function (errorColour) { return function (defaultColour) {
    return errorMessage === undefined || errorMessage === null ? defaultColour : errorColour;
}; }; };
//# sourceMappingURL=getColourDeciderGivenAnError.js.map